import React from 'react'

const Sidebar = (props) => {
  const styles = {
    sideBar: {
      background: '#d1d1d1',
      height: '100%',
      width: 190,
    },
    sideBarHeader:{
      background: '#686868',
      color: 'white',
      height: 45
    },
    sideBarTitle:{
      fontSize: 16,
      padding: '15px 0 0 15px'
    },
  }
  const { steps, currentPage, highestPage, goToPage } = props
  return(
    <div style={styles.sideBar}>
      <div style={styles.sideBarHeader}>
        <div style={styles.sideBarTitle}>Integration Steps</div>
      </div>
      <div style={{ width:190, padding: '2px 2px 4px 0', height:'calc(100% - 44px)' }}>
        <div style={{ overflowY:'scroll', overflowX:'hidden', height:'100%', width:187 }} className="wizard-sidebar-content">
          <div style={{ margin:5 }} />
          {steps.map((step, i) =>
            <div key={i} style={{ width:187 }}>
              <div
                className="wizard-step-circle"
                style={{
                  marginLeft:16,
                  background: currentPage === i + 1 ? 'rgba(58, 145, 220, 0.7)' : 
                    i+1 <= highestPage ? 'white': '#E7E7E7',
                  fontWeight: 'bold',
                  cursor:i+1 <= highestPage ? 'pointer' : 'default'
                }}
                onClick={()=>goToPage(i)}
              >
                {i + 1}
              </div>
              <div style={{
                fontSize:12,
                display:'inline-block',
                width: 102,
                verticalAlign: 'middle'
              }}
              >
                {step.title}
              </div>
            </div>
          )}
          <div style={{ height:10 }} />
        </div>
      </div>
    </div>
  )
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Sidebar.js